import { isFieldErrorResponse, useApiOrdersV1PurchaseOrdersCreate } from 'api';
import { UseFormReturn } from 'form';

import { UploadDocumentProps } from '../../../document';
import { CreateFormInputValues, CreateFormValues } from '../../pages/PurchaseOrderCreate/PurchaseOrderCreate';
import { redirectToPurchaseOrderConfirmationPage } from '../../utils/redirectToPurchaseOrderConfirmationPage';
import { useUploadAndCreatePurchaseOrderDocument } from '..';

export const useCreatePurchaseOrder = (form: UseFormReturn<CreateFormInputValues, unknown, CreateFormValues>) => {
  const { setError, getValues } = form;
  const uploadAndCreateDocument = useUploadAndCreatePurchaseOrderDocument();

  return useApiOrdersV1PurchaseOrdersCreate({
    mutation: {
      onError(error) {
        if (isFieldErrorResponse(error)) {
          Object.keys(error.response?.data).forEach((field) => {
            setError(field as keyof CreateFormValues, { message: error.response.data[field] });
          });
        }
      },
      async onSuccess(data) {
        const documents = getValues().documents;
        if (documents) {
          await Promise.all(
            documents?.map((document: UploadDocumentProps) => uploadAndCreateDocument(document, { slug: data.slug }))
          );
        }
        redirectToPurchaseOrderConfirmationPage(data.slug);
      },
    },
  });
};
